/**
 * V2 wrapper for Dependencies tab. Used by ViewDetailV2 (and future TableDetailV2 / MappingDetailV2).
 * @see NewDependencies — shared implementation used by Table/Mapping details.
 */
import { NewDependencies } from './NewDependencies'

export const NewDependenciesV2 = () => <NewDependencies />
